/**
 * <x-ui.inline-edit>: Klick → Feld, Enter/Verlassen speichert, Esc bricht ab.
 * Der aktuelle Wert kommt aus data-value (wird beim Re-Render aktualisiert).
 */
export function registerInline(Alpine) {
    Alpine.data('nnInline', (method, args, type) => ({
        editing: false,
        saving: false,
        saved: false,
        error: null,
        value: '',
        original: '',

        start() {
            if (this.editing || this.saving) return;
            this.original = this.$root.dataset.value ?? '';
            this.value = this.original;
            this.error = null;
            this.editing = true;
            this.$nextTick(() => {
                const input = this.$refs.input;
                if (!input) return;
                input.focus();
                if (type === 'text' || type === 'textarea') input.select?.();
            });
        },

        cancel() {
            this.editing = false;
            this.error = null;
        },

        async commit() {
            if (!this.editing || this.saving) return;

            if (String(this.value ?? '') === String(this.original ?? '')) {
                this.cancel();
                return;
            }

            this.saving = true;
            let result;
            try {
                result = await this.$wire.$call(method, ...args, this.value);
            } finally {
                this.saving = false;
            }

            if (result && result.ok === false) {
                this.error = result.message || 'Ungültiger Wert';
                this.$nextTick(() => this.$refs.input?.focus());
                return;
            }

            this.original = this.value;
            this.editing = false;
            this.error = null;
            this.saved = true;
            setTimeout(() => (this.saved = false), 1200);
        },
    }));
}
